const STORAGE_KEY = "justtrackit.theme";
const VALID = new Set(["dark", "light", "system"]);

export function getStoredTheme() {
  if (typeof window === "undefined") return "system";
  const stored = window.localStorage.getItem(STORAGE_KEY);
  return VALID.has(stored) ? stored : "system";
}

export function resolveTheme(themeName) {
  if (themeName === "system") {
    if (typeof window === "undefined") return "dark";
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  }
  return themeName === "light" ? "light" : "dark";
}

export function applyTheme(themeName) {
  if (typeof document === "undefined") return;
  const resolved = resolveTheme(themeName);
  document.documentElement.classList.toggle("dark", resolved === "dark");
  document.documentElement.classList.toggle("light", resolved === "light");
  document
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute("content", resolved === "dark" ? "#0c0f17" : "#fafbfd");
}

export function setStoredTheme(themeName) {
  if (typeof window === "undefined") return;
  const safe = VALID.has(themeName) ? themeName : "system";
  window.localStorage.setItem(STORAGE_KEY, safe);
  applyTheme(safe);
}

export function initializeTheme() {
  const theme = getStoredTheme();
  applyTheme(theme);

  if (typeof window !== "undefined" && theme === "system") {
    const media = window.matchMedia("(prefers-color-scheme: dark)");
    const listener = () => applyTheme("system");
    media.addEventListener?.("change", listener);
  }
}
